import {FormDatePickerCombo, FormInputText} from "base/form/components";
import Grid from "@mui/material/Grid";

const PermitApplicationFellingFormFields = ({disabled, isExtension = false}) => {
    return (
        <Grid container columnSpacing={1}>
            <FormDatePickerCombo
                startDateName={"felling_start_date"}
                startDateLabel={isExtension ? "Nova data de início" : "Data de início"}
                endDateName={"felling_end_date"}
                endDateLabel={
                    isExtension ? "Nova data de caducidade" : "Data de caducidade"
                }
                required={isExtension ? true : false}
                disabled={disabled}
            />

            {isExtension ? null : (
                <Grid item xs={12} sm={6}>
                    <FormInputText
                        name="felling_beneficiary"
                        label="Beneficiário/a"
                        disabled={disabled}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default PermitApplicationFellingFormFields;
